export const successConstants = {
    MEASURE_GET_REQUEST: 'MEASURE_GET_REQUEST',
    MEASURE_GET_SUCCESS: 'MEASURE_GET_SUCCESS',
    MEASURE_GET_FAILURE: 'MEASURE_GET_FAILURE'
}